/** Compliance dashboard card icon. */
export function ComplianceIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 1.25 13 3v3.64c0 3.23-2.04 6.15-5 7.11-2.96-.96-5-3.88-5-7.11V3l5-1.75Z"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinejoin="round"
      />
      <path
        d="m5.4 7.9 1.55 1.55L10.8 5.6"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
